import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "speach-polls-results-container"
};
const _hoisted_2 = {
  class: "polls-results-title"
};
const _hoisted_3 = {
  class: "polls-results-select-block"
};
const _hoisted_4 = {
  class: "polls-results-select-label"
};
const _hoisted_5 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_select = _resolveComponent("w-select");
  const _component_poll_quiz_statistics = _resolveComponent("poll-quiz-statistics");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('analytics.speach.pollsResults.title')), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('analytics.speach.pollsResults.pollSelectLabel')), 1), _createVNode(_component_w_select, {
    options: _ctx.pollsSelectItems,
    "value-key": 'id',
    value: _ctx.selectedPollId,
    onChange: _ctx.onOptionChange
  }, null, 8, ["options", "value", "onChange"])]), _ctx.pollsSelectItems.length ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    class: "poll-detail-link",
    href: `/analytics/poll/${_ctx.currentPollQuizStatistics?.id}`
  }, _toDisplayString(_ctx.$t('analytics.speach.pollsResults.openPollLink')), 9, _hoisted_5)) : _createCommentVNode("", true), _createVNode(_component_poll_quiz_statistics, {
    class: "poll-statistics",
    "quiz-statistics-data-input": _ctx.currentPollQuizStatistics
  }, null, 8, ["quiz-statistics-data-input"])]);
}